import { Theme } from '@mui/material'

const DESKTOP_CONTAINER_WIDTH = '350px'
const PULSE_ANIMATION_SIZE = '100vw'
const LF_IMAGE_SIZE = '147px'

const classes = {
  footer: {
    height: 'auto',
  },
  lfImageContainer: {
    width: LF_IMAGE_SIZE,
    height: LF_IMAGE_SIZE,
    textAlign: 'center',
    position: 'relative',
  },
  lfImage: {
    position: 'relative' as const,
  },
  pulseAnimation: {
    position: 'absolute' as const,
    top: `calc((${PULSE_ANIMATION_SIZE} / 2 - ${LF_IMAGE_SIZE} / 2) * -1 )`,
    left: `calc((${PULSE_ANIMATION_SIZE} / 2 - ${LF_IMAGE_SIZE} / 2) * -1)`,
    width: PULSE_ANIMATION_SIZE,
  },
  pulseAnimationLargeScreen: {
    position: 'absolute' as const,
    top: `calc((${DESKTOP_CONTAINER_WIDTH} / 2 - ${LF_IMAGE_SIZE} / 2) * -1 )`,
    left: `calc((${DESKTOP_CONTAINER_WIDTH} / 2 - ${LF_IMAGE_SIZE} / 2) * -1)`,
    width: DESKTOP_CONTAINER_WIDTH,
  },
  abovePulse: {
    zIndex: 0,
  },
  mainContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    marginTop: '120px',
  },
  statusLabel: {
    fontWeight: '500',
  },
  statusContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    marginX: 2,
  },
  statusTitle: {
    textAlign: 'center',
  },
  statusMessage: {
    textAlign: 'center',
  },
  errorContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1,
  },
  connectedContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1,
  },
  lowSignalContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
  },
  accordion: (theme: Theme) => ({
    marginX: theme.spacing(-2),
    '&.Mui-expanded': {
      marginX: theme.spacing(-2),
    },
  }),
  accordionDetails: {
    paddingY: 0,
  },
  troubleshootingMainContainer: {
    flexDirection: 'column',
    gap: 3,
  },
  troubleshootingSection: {
    flexDirection: 'column',
    gap: 2,
  },
  sectionTitle: {
    fontWeight: '500',
  },
  listContainer: {
    marginY: '12px',
  },
  descriptionText: {
    marginBottom: '12px',
  },
  noteText: {
    marginTop: '8px',
  },
  helpContainer: (isMobile: boolean) => ({
    backgroundColor: isMobile ? 'ui.surfaceContainer' : 'secondary.light',
    padding: '16px',
    borderRadius: '4px',
    gap: '18px',
  }),
}

export default classes
